<template>
<v-snackbar
    v-model="snackbar"
    top
    :timeout="timeout"
>
    <div class="d-flex align-center justify-space-between gap-2">
        <span>{{ text }}</span>

        <v-btn
            color="white"
            outlined
            @click="snackbar = false"
        >
            Close
        </v-btn>
    </div>
</v-snackbar>
</template>

<script>
export default {
    data() {
        return {
            text: null,
            snackbar: false,
            timeout: 3000
        }
    },

    created () {
        this.$event_bus.$on('snackbar', this.show);
        this.$event_bus.$on('close-snackbar', this.close);
    },

    beforeDestroy () {
        this.$event_bus.$off('snackbar',this.show);
        this.$event_bus.$off('close-snackbar',this.close);
    },

    methods: {
        
        show(params) {
            if ( params == null ) return;

            this.text = params.text;
            this.timeout = params.timeout == null ? 3000 : params.timeout;

            if ( this.timeout < 0 ) this.timeout = null;

            this.snackbar = true;
        },

        close() {
            this.snackbar = false;
        }
       
    },
}
</script>

<style lang="scss" scoped>

</style>